import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../api/auth.api";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading,  setLoading]  = useState(false);
  const [error,    setError]    = useState("");
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    if (!username.trim() || !password.trim()) {
      setError("Preencha usuário e senha.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await login(username.trim(), password);
      navigate("/", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.error || err?.response?.data?.message;
      setError(msg || "Não foi possível conectar ao servidor. Tente novamente.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={bg}>
      {/* Glow radial no fundo */}
      <div style={glow} />

      <form onSubmit={handleSubmit} style={card} noValidate>

        {/* Logo */}
        <div style={logoWrap}>
          <div style={logo}>R</div>
          <div>
            <div style={brandName}>Redmine</div>
            <div style={brandSub}>Sprint Board</div>
          </div>
        </div>

        <div style={divider} />

        <h2 style={title}>Entrar</h2>
        <p style={subtitle}>Use suas credenciais do Redmine</p>

        {/* Usuário */}
        <label style={label}>Usuário</label>
        <input
          type="text"
          value={username}
          onChange={e => { setUsername(e.target.value); setError(""); }}
          placeholder="ex: ana.maria"
          autoComplete="username"
          disabled={loading}
          style={input}
          onFocus={e => { e.target.style.borderColor = "rgba(96,165,250,0.55)"; e.target.style.boxShadow = "0 0 0 3px rgba(96,165,250,0.12)"; }}
          onBlur={e =>  { e.target.style.borderColor = "rgba(96,165,250,0.18)"; e.target.style.boxShadow = "none"; }}
        />

        {/* Senha */}
        <label style={{ ...label, marginTop: 14 }}>Senha</label>
        <input
          type="password"
          value={password}
          onChange={e => { setPassword(e.target.value); setError(""); }}
          placeholder="Senha do Redmine"
          autoComplete="current-password"
          disabled={loading}
          style={input}
          onFocus={e => { e.target.style.borderColor = "rgba(96,165,250,0.55)"; e.target.style.boxShadow = "0 0 0 3px rgba(96,165,250,0.12)"; }}
          onBlur={e =>  { e.target.style.borderColor = "rgba(96,165,250,0.18)"; e.target.style.boxShadow = "none"; }}
        />

        {/* Erro */}
        {error && (
          <div style={errorBox}>
            <span style={{ fontSize: 14 }}>⚠</span>
            <span>{error}</span>
          </div>
        )}

        {/* Botão */}
        <button
          type="submit"
          disabled={loading}
          style={{ ...btn, opacity: loading ? 0.7 : 1, cursor: loading ? "not-allowed" : "pointer" }}
          onMouseEnter={e => { if (!loading) e.currentTarget.style.filter = "brightness(1.12)"; }}
          onMouseLeave={e => { e.currentTarget.style.filter = "none"; }}
        >
          {loading ? (
            <span style={{ display: "flex", alignItems: "center", gap: 8, justifyContent: "center" }}>
              <Spinner /> Autenticando...
            </span>
          ) : "Entrar"}
        </button>

        <p style={hint}>Acesso restrito a usuários autorizados.</p>
      </form>
    </div>
  );
}

function Spinner() {
  return (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none" style={{ animation: "spin 0.8s linear infinite" }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <circle cx={12} cy={12} r={9} stroke="rgba(255,255,255,0.3)" strokeWidth={3} />
      <path d="M12 3a9 9 0 0 1 9 9" stroke="#fff" strokeWidth={3} strokeLinecap="round" />
    </svg>
  );
}

/* ── Styles ─────────────────────────────────────────── */

const bg = {
  minHeight: "100vh",
  background: "linear-gradient(135deg, #060d1e 0%, #08122a 60%, #060d1e 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: 20,
  position: "relative",
  overflow: "hidden",
};

const glow = {
  position: "absolute",
  top: "30%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  height: 400,
  background: "radial-gradient(ellipse, rgba(59,130,246,0.1) 0%, transparent 70%)",
  pointerEvents: "none",
};

const card = {
  background: "rgba(11,22,42,0.85)",
  backdropFilter: "blur(24px)",
  WebkitBackdropFilter: "blur(24px)",
  border: "1px solid rgba(96,165,250,0.15)",
  borderRadius: 20,
  padding: "36px 40px",
  width: "100%",
  maxWidth: 400,
  boxShadow: "0 24px 64px rgba(0,0,0,0.6), inset 0 1px 0 rgba(255,255,255,0.05)",
  display: "flex",
  flexDirection: "column",
  position: "relative",
  zIndex: 1,
};

const logoWrap = {
  display: "flex",
  alignItems: "center",
  gap: 12,
  marginBottom: 20,
};

const logo = {
  width: 44,
  height: 44,
  borderRadius: 12,
  background: "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 800,
  fontSize: 20,
  color: "#fff",
  boxShadow: "0 0 20px rgba(6,182,212,0.45)",
  flexShrink: 0,
};

const brandName = { color: "#e2e8f0", fontWeight: 700, fontSize: 16, letterSpacing: 0.3 };
const brandSub  = { color: "#475569", fontSize: 10, marginTop: 2, letterSpacing: 0.8, textTransform: "uppercase" };

const divider = { height: 1, background: "rgba(96,165,250,0.1)", marginBottom: 24 };

const title    = { fontSize: 20, fontWeight: 800, color: "#f1f5f9", letterSpacing: -0.5, margin: "0 0 4px" };
const subtitle = { fontSize: 12, color: "#475569", margin: "0 0 24px" };

const label = {
  fontSize: 11,
  fontWeight: 700,
  color: "#64748b",
  textTransform: "uppercase",
  letterSpacing: 0.8,
  marginBottom: 6,
  display: "block",
};

const input = {
  width: "100%",
  padding: "11px 14px",
  background: "rgba(255,255,255,0.04)",
  border: "1px solid rgba(96,165,250,0.18)",
  borderRadius: 10,
  color: "#e2e8f0",
  fontSize: 14,
  outline: "none",
  transition: "border-color 0.15s, box-shadow 0.15s",
  boxSizing: "border-box",
  fontFamily: "Inter, sans-serif",
};

const errorBox = {
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginTop: 14,
  padding: "10px 14px",
  background: "rgba(248,113,113,0.1)",
  border: "1px solid rgba(248,113,113,0.3)",
  borderRadius: 9,
  color: "#f87171",
  fontSize: 13,
};

const btn = {
  marginTop: 22,
  width: "100%",
  padding: "13px",
  borderRadius: 11,
  border: "none",
  background: "linear-gradient(135deg, #3b82f6 0%, #06b6d4 100%)",
  color: "#fff",
  fontSize: 14,
  fontWeight: 700,
  letterSpacing: 0.3,
  transition: "filter 0.15s",
  boxShadow: "0 4px 20px rgba(59,130,246,0.35)",
  fontFamily: "Inter, sans-serif",
};

const hint = {
  textAlign: "center",
  fontSize: 11,
  color: "#334155",
  marginTop: 16,
  marginBottom: 0,
};
